// extracted by mini-css-extract-plugin
module.exports = {"Container":"LabeledInput_Container__kizbl","Input":"LabeledInput_Input__ZagFA"};